import { saveTableSnapshotsEndpoint } from 'root/src/shared/snapshots/endpoints/saveTableSnapshots.endpoint';
export const snapshotEndpoints = Object.assign({}, saveTableSnapshotsEndpoint);
